var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarbon = function SvgCarbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5B90D",
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M33.75 20.75c.18-.64.37-1.37.37-2.11 0-3.66-3.02-6.68-6.68-6.68a6.61 6.61 0 0 0-6.41 4.94c-.46-.18-1.01-.27-1.56-.27-2.38 0-4.21 1.83-4.39 4.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M30.82 21.02c.97-.37 2.21-.43 2.93-.27 2.37.52 3.94 2.56 4.03 5.03 0 2.84-2.29 5.13-5.13 5.13h-3.02c-1.1 2.2-3.29 3.75-5.95 3.75s-4.85-1.56-5.95-3.75h-3.75c-2.84 0-5.13-2.29-5.13-5.13s2.29-5.13 5.13-5.13c1.55 0 2.38.55 3.02 1.1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgCarbon;